export default [
  {
    to: 'December 31, 2018',
    from: 'January 01, 2018',
    year: 2018,
    __typename: 'InterimPeriod'
  }
]